import { SubjectData } from 'shell/models/person';
import { DateTime } from 'luxon';
import { MunicipalityAnprVM } from 'shell/components/shared/municipality-list';
import {
  // getExpirationDate,
  getValidity,
} from 'front-office/utils/release-id-card-document-transformer';
import { AccordionIdentityCardVM } from 'front-office/view-models/registration-id-card';

export const transformIdentityCard = (person: SubjectData): AccordionIdentityCardVM | undefined => {
  const municipality: MunicipalityAnprVM | undefined = person.cartaIdentita?.comuneRilascio
    ? {
        description: person.cartaIdentita?.comuneRilascio?.nomeComune || '',
        province: person.cartaIdentita?.comuneRilascio?.siglaProvinciaIstat || '',
        locality: person.cartaIdentita?.comuneRilascio?.descrizioneLocalita || '',
        istatCode: person.cartaIdentita?.comuneRilascio?.codiceIstat || '',
        id: person.cartaIdentita?.comuneRilascio?.codiceIstat || '',
      }
    : undefined;

  const originReturnData: AccordionIdentityCardVM | undefined = person.cartaIdentita
    ? {
        number: person.cartaIdentita?.numero || '',
        type:
          person.cartaIdentita?.cartaceaElettronica === '1'
            ? '3'
            : person.cartaIdentita?.cartaceaElettronica || '', // TODO cartaceaElettronica?
        expatriationBan: person.cartaIdentita?.interdizioneEspatrio === 'S' ? true : false,
        releaseDate: person.cartaIdentita?.dataRilascio
          ? DateTime.fromISO(person.cartaIdentita?.dataRilascio)
          : null,
        expirationDate: person.cartaIdentita?.dataScadenza
          ? DateTime.fromISO(person.cartaIdentita?.dataScadenza)
          : null,
        cancellationDate: person.cartaIdentita?.dataAnnullamento
          ? DateTime.fromISO(person.cartaIdentita?.dataAnnullamento)
          : null,
        stillValid: getValidity(person?.cartaIdentita?.dataScadenza) || '',
        municipality: person.cartaIdentita?.comuneRilascio?.nomeComune ? municipality : null,
        province: person.cartaIdentita?.comuneRilascio?.siglaProvinciaIstat || '',
        location: person.cartaIdentita?.comuneRilascio?.descrizioneLocalita || '',
        consulateCode: person.cartaIdentita?.consolatoRilascio?.codiceConsolato || '',
        consulateDescription: person.cartaIdentita?.consolatoRilascio?.descrizioneConsolato || '',
        isConsulateRelease: person.cartaIdentita?.consolatoRilascio?.codiceConsolato ? true : false,
      }
    : undefined;

  // if (originReturnData) {
  //   originReturnData.expirationDate = getExpirationDate(person);
  // }

  return originReturnData;
};
